import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6f0641e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pop" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon" }, null, -1))
const _hoisted_6 = { class: "search-wrap" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "item-header bold"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "group-item-text" }
const _hoisted_12 = { class: "main bold" }
const _hoisted_13 = { class: "sub" }
const _hoisted_14 = { class: "group-item-checkbox" }
const _hoisted_15 = {
  key: 0,
  class: "icon icon-check"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "group-item-text" }
const _hoisted_18 = { class: "main bold" }
const _hoisted_19 = { class: "sub" }
const _hoisted_20 = { class: "group-item-checkbox" }
const _hoisted_21 = {
  key: 0,
  class: "icon icon-check"
}
const _hoisted_22 = {
  key: 0,
  class: "circle-icon"
}
const _hoisted_23 = {
  key: 1,
  class: "circle-icon"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 0,
  class: "item-header bold"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "group-item-text" }
const _hoisted_28 = { class: "main bold" }
const _hoisted_29 = { class: "sub" }
const _hoisted_30 = { class: "group-item-checkbox" }
const _hoisted_31 = {
  key: 0,
  class: "icon icon-check"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "group-item-text" }
const _hoisted_34 = { class: "main bold" }
const _hoisted_35 = { class: "sub" }
const _hoisted_36 = { class: "group-item-checkbox" }
const _hoisted_37 = {
  key: 0,
  class: "icon icon-check"
}
const _hoisted_38 = {
  key: 0,
  class: "circle-icon"
}
const _hoisted_39 = {
  key: 1,
  class: "circle-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_message_share_settings = _resolveComponent("app-message-share-settings")!
  const _component_app_navigation = _resolveComponent("app-navigation")!
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_no_message = _resolveComponent("app-no-message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "javascript:void(0);",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
        class: "back-link"
      }, _hoisted_4),
      _createElementVNode("a", {
        href: "javascript:void(0);",
        class: _normalizeClass([{ disabled: !_ctx.selectedItem }, "back-link"]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onShare && _ctx.onShare(...args)), ["prevent"]))
      }, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('share.by.message.popup.share.button')), 1)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_app_search, {
        modelValue: _ctx.search,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
        onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = ''))
      }, null, 8, ["modelValue"])
    ]),
    (_ctx.isMy)
      ? (_openBlock(), _createBlock(_component_app_message_share_settings, {
          key: 0,
          onUpdateSettings: _ctx.updateShareSettings,
          "share-settings": _ctx.shareSettings
        }, null, 8, ["onUpdateSettings", "share-settings"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_app_navigation, {
        class: "share-navigation",
        "navigation-data": _ctx.navigationData,
        onOnSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedType = $event)),
        "selected-tab": _ctx.selectedType,
        "use-as-select": ""
      }, null, 8, ["navigation-data", "selected-tab"]),
      (_ctx.selectedType === 'contacts')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.contactList.length && !_ctx.noContactsFound)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_9, "My Contacts"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (item) => {
              return (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                key: item.accountId,
                class: "group-item"
              }, {
                icon: _withCtx(() => [
                  (item.targetType === 'GROUP')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_app_lazy_image, {
                          url: _ctx.resolveGroupPhotoUrl(item),
                          alt: "group photo"
                        }, null, 8, ["url"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_app_lazy_image, {
                          url: _ctx.resolveContactPhotoUrl(item),
                          alt: "contact photo"
                        }, null, 8, ["url"])
                      ]))
                ]),
                default: _withCtx(() => [
                  (item.targetType === 'GROUP')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "group-item",
                        onClick: ($event: any) => (_ctx.onSelectGroup(item))
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(item.name), 1),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(item.groupInfo), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          (item.id === _ctx.selectedItem?.id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_10))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "group-item",
                        onClick: ($event: any) => (_ctx.onSelectContact(item))
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.resolveFullName(item)), 1),
                          _createElementVNode("p", _hoisted_19, _toDisplayString(item.speciality), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          (item.accountId === _ctx.selectedItem?.id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_16))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
            (_ctx.groupList.length && !_ctx.noContactsFound)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_25, "My Groups"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredGroups, (item) => {
              return (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                key: item.accountId,
                class: "group-item"
              }, {
                icon: _withCtx(() => [
                  (item.targetType === 'GROUP')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createVNode(_component_app_lazy_image, {
                          url: _ctx.resolveGroupPhotoUrl(item),
                          alt: "group photo"
                        }, null, 8, ["url"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createVNode(_component_app_lazy_image, {
                          url: _ctx.resolveContactPhotoUrl(item),
                          alt: "contact photo"
                        }, null, 8, ["url"])
                      ]))
                ]),
                default: _withCtx(() => [
                  (item.targetType === 'GROUP')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "group-item",
                        onClick: ($event: any) => (_ctx.onSelectGroup(item))
                      }, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("p", _hoisted_28, _toDisplayString(item.name), 1),
                          _createElementVNode("p", _hoisted_29, _toDisplayString(item.groupInfo), 1)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          (item.id === _ctx.selectedItem?.id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_26))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "group-item",
                        onClick: ($event: any) => (_ctx.onSelectContact(item))
                      }, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.resolveFullName(item)), 1),
                          _createElementVNode("p", _hoisted_35, _toDisplayString(item.speciality), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          (item.accountId === _ctx.selectedItem?.id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_37))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_32))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
    ]),
    (_ctx.noContactsFound)
      ? (_openBlock(), _createBlock(_component_app_no_message, {
          key: 1,
          icon: _ctx.noContactsFound.icon,
          class: "no-contacts-found"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.noContactsFound.text), 1)
          ]),
          _: 1
        }, 8, ["icon"]))
      : _createCommentVNode("", true)
  ]))
}